"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSizes = exports.transformColours = void 0;
var _productHelpers = require("./productHelpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var generate = function generate(_ref) {
  var _ref$hasSizeOptions = _ref.hasSizeOptions,
    hasSizeOptions = _ref$hasSizeOptions === void 0 ? undefined : _ref$hasSizeOptions,
    options = _ref.options,
    optionName = _ref.optionName,
    skus = _ref.skus,
    swatches = _ref.swatches,
    _ref$selectedColour = _ref.selectedColour,
    selectedColour = _ref$selectedColour === void 0 ? null : _ref$selectedColour;
  if (!options || !options.length) {
    return [];
  }
  var relevantSkus = selectedColour ? (0, _productHelpers.filterSkusBy)({
    colour: selectedColour
  }, {
    skus: skus
  }) : skus;
  var relevantOptions = optionName === 'size' && selectedColour ? relevantSkus.map(function (sku) {
    return sku.size;
  }) : options;
  return relevantOptions.reduce(function (newOptions, value) {
    var skuForThisOptionValue = relevantSkus.find(function (sku) {
      return sku[optionName] === value;
    });
    if (!skuForThisOptionValue) {
      return newOptions;
    }
    var pdpUrl = skuForThisOptionValue.url,
      availableToOrder = skuForThisOptionValue.availableToOrder,
      stockLevel = skuForThisOptionValue.stockLevel,
      now = skuForThisOptionValue.prices.now;
    var price = optionName === 'colour' && hasSizeOptions ? undefined : now;
    var inStock = stockLevel >= 0 ? stockLevel > 0 : availableToOrder;
    var props = {
      pdpUrl: pdpUrl,
      inStock: inStock,
      price: price
    };
    if (optionName === 'colour') {
      props.inStock = (0, _productHelpers.hasSkusInStockForColour)(value, skus);
      props.swatchImage = (0, _productHelpers.getSwatchImage)(value, {
        swatches: swatches
      });
    }
    return [].concat(_toConsumableArray(newOptions), [_objectSpread(_defineProperty({}, optionName, value), props)]);
  }, []);
};
var sortColours = function sortColours(colours) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var orderedColours = order.reduce(function (acc, name) {
    var match = colours.find(function (colour) {
      return colour === name;
    });
    return match ? acc.concat(match) : acc;
  }, []);
  var missingColours = colours.filter(function (colour) {
    return !order.includes(colour);
  });
  return orderedColours.concat(missingColours);
};
var transformColours = exports.transformColours = function transformColours(_ref2) {
  var colours = _ref2.colours,
    skus = _ref2.skus,
    swatches = _ref2.swatches;
  var hasSizeOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return generate({
    options: sortColours(colours, order),
    optionName: 'colour',
    skus: skus,
    swatches: swatches,
    hasSizeOptions: hasSizeOptions
  });
};
var transformSizes = exports.transformSizes = function transformSizes(_ref3) {
  var sizes = _ref3.sizes,
    skus = _ref3.skus;
  var selectedColour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return generate({
    options: sizes,
    optionName: 'size',
    skus: skus,
    selectedColour: selectedColour
  });
};